import axios from 'axios'
import config from '@/config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from '@/constants/api.constant'
//import store, { signOutSuccess } from '../store'

const unauthorizedCode = [401]
const forbiddenCode = [403]

const BaseService = axios.create({
  timeout: 240000,
  baseURL: config.NEXT_PUBLIC_BASE_URL,
})

BaseService.interceptors.request.use(
  (config) => {
    let accessToken = localStorage.getItem("accessToken")
    
    if (!accessToken) {
      // const { auth } = store.getState()
      // accessToken = auth.session.token
    }
    
    if (accessToken) {
      config.headers[
        REQUEST_HEADER_AUTH_KEY
        ] = `${TOKEN_TYPE}${accessToken}`
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error

    if (response && unauthorizedCode.includes(response.status)) {
      //store.dispatch(signOutSuccess())
    }

    if (response && forbiddenCode.includes(response.status)) {
      // Navigate to forbidden page
      window.location.href = '/forbidden'
    }

    return Promise.reject(error)
  }
)

export default BaseService
